














































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { deviceServer, doublePrevention, regionServe } from '@/api/installServer';
import { arrayToTree } from '@/util/array';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  mixins: [TableStripe],
})
export default class PublicProp extends Vue {
  visible = false;
  title = '绑定风险点、危险源';
  deviceGuid: any = '';
  formData: any = {};
  // private areaId = ''; // 区域 id
  // private areaName = ''; // 区域 name
  // private riskPointId = ''; // 风险点 id
  // private dangerSourceId = ''; // 危险源 id
  private areaNameList: any = []; // 所在区域
  private riskPointList: any = []; // 风险点
  private dangerSourceIdList: any = []; // 危险源
  private helpDangerSourceIdList: any = [];

  ruleForm: any = {
    name: [
      { required: true, message: '请输入活动名称', trigger: 'blur' },
      { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' },
    ],
  };
  private patrolFrequencyUnitList: any = [
    {
      id: 'day',
      name: '天',
    },
    {
      id: 'week',
      name: '周',
    },
    {
      id: 'month',
      name: '月',
    },
    {
      id: 'timeFrame',
      name: '时间段',
    },
  ];
  @Watch('formData.patrolFrequencyUnit')
  private patrolFrequencyUnitChange(val: any) {
    if (val !== 'timeFrame') {
      this.formData.timeQuantumList = [];
    }
  }

  showDialog(data: any) {
    this.getSpaceAreaData(); // 获取区域列表
    this.deviceGuid = data;
    this.getBindDevice(data); // 需要绑定的数据
    this.visible = true;
  }

  hideDialog() {
    this.visible = false;
  }

  /* 获取绑定的数据 */
  getBindDevice(id: any) {
    this.riskPointList = [];
    this.helpDangerSourceIdList = [];
    this.dangerSourceIdList = [];
    deviceServer.getBindDevice(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        if (!res.data.timeQuantumList) {
          this.formData.timeQuantumList = [];
        }
        if (this.formData.areaId) {
          doublePrevention
            .getRiskAll({
              areaId: this.formData.areaId,
            })
            .then((res: any) => {
              if (res.code === '200') {
                res.data.forEach((type: any) => {
                  if (type.type === '风险点') {
                    this.riskPointList.push(type);
                  }
                  if (type.type === '危险源') {
                    this.helpDangerSourceIdList.push(type);
                  }
                });
                // // 根据风险点id获取危险源
                if (this.formData.riskPointId) {
                  this.helpDangerSourceIdList.forEach((item: any) => {
                    if (item.pid === this.formData.riskPointId) {
                      this.dangerSourceIdList.push(item);
                    }
                  });
                }
              } else {
                this.$message.warning('获取风险点和危险源的数据失败！');
              }
            });
        }
      } else {
        this.$message.warning('数据获取失败');
      }
    });
  }

  submitForm() {
    this.bindDevice();
  }

  /* 绑定 */
  bindDevice() {
    deviceServer.bindDevice(this.deviceGuid, this.formData).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('绑定成功！');
        this.hideDialog();
      } else {
        this.$message.success(res.msg);
      }
    });
  }

  private getSpaceAreaData() {
    this.areaNameList = [];
    regionServe.getRegionAllData({}).then((res: any) => {
      if (res.code === '200') {
        this.areaNameList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  // 风险点和危险源的下拉
  getRiskData(name: any) {
    this.riskPointList = [];
    this.helpDangerSourceIdList = [];
    this.dangerSourceIdList = [];
    this.formData.riskPoint = '';
    this.formData.dangerSource = '';
    this.formData.riskPointId = '';
    this.formData.dangerSourceId = '';
    if (name.length > 0) {
      const checkedNode = (this.$refs['elCascader'] as any).panel.getNodeByValue(name);
      this.formData.areaName = checkedNode.label;
      this.formData.areaId = checkedNode.value;
      doublePrevention
        .getRiskAll({
          areaId: this.formData.areaId,
        })
        .then((res: any) => {
          if (res.code === '200') {
            res.data.forEach((type: any) => {
              if (type.type === '风险点') {
                this.riskPointList.push(type);
              }
              if (type.type === '危险源') {
                this.helpDangerSourceIdList.push(type);
              }
            });
          } else {
            this.$message.warning('获取风险点和危险源的数据失败！');
          }
        });
    } else {
      this.formData.areaName = '';
      this.formData.areaId = '';
    }
  }

  // 风险点
  getRiskPointId(name: any) {
    this.dangerSourceIdList = [];
    this.formData.dangerSource = '';
    this.formData.dangerSourceId = '';
    const selectedName1 = this.riskPointList.find((item: any) => {
      return item.name === name;
    });
    this.formData.riskPointId = selectedName1.id;
    this.helpDangerSourceIdList.forEach((data: any) => {
      if (data.pid === this.formData.riskPointId) {
        this.dangerSourceIdList.push(data);
      }
    });
  }

  // 危险源
  getDangerSourceId(name: any) {
    const selectedName2 = this.dangerSourceIdList.find((item: any) => {
      return item.name === name;
    });
    this.formData.dangerSourceId = selectedName2.id;
  }
  addChildTaskList() {
    this.formData.timeQuantumList.push({
      startTime: '',
      endTime: '',
    });
  }
  deleteChildTaskList(index: any) {
    this.formData.timeQuantumList.splice(index, 1);
  }
}
